/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, {
  useEffect,
  useContext,
  useState,
  useRef,
  useCallback,
  useMemo,
} from 'react'
import { Button, Empty, message, DatePicker, Icon, Tooltip, Modal } from 'antd'
import { UtilityUnitSelection, getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
import { getUnitCodeCauseCodeMapList, hasAccesPermits } from 'core/utils'
import { headers as card97headers } from 'card-data/Card97Antd'
import KpiData, { getTitle as getKpiValueTitle } from './component/KpiData'
import { CriteriaRow, Title, Content, FullHeightSizer } from 'core/screen-util'

import {
  UnitSelectionContext,
  DatePickerContext,
  SpinContext,
  ErrorContext,
} from 'context'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getUnits,
  getCauseCodeMap,
  isUnitLoading,
  getAmlificationCode,
  getFailCode,
  getPermitActions,
  getEnvConfig,
  isAdminType,
  getUtilities,
} from 'core/selectors'

import * as ScreenPermissions from 'core/EventActions'

import {
  getMonthlyViewData,
  // getAmpCodeMgmtInfo,
  // getFailCodeMgmtInfo,
  getSystemConfigurationInfo,
  getDataItems,
  getKpi,
  getCauseCodeAll,
} from 'api/pgads'
import TmpCard97 from './component/TmpCard97'
import MonthlyGraph from './component/MonthlyGraph'
import Card97EditPrompt from 'card-data/component/card97/Card97EditAntd'

import KpiModal from './component/KpiModal'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'
const title = 'Monthly Operation View'

const MonthlyPerformance = ({
  apiTargetInfo,
  utilityNameMap,
  unitNameMap,
  // utilityUnitMap,
  units,
  causeCodeMap,
  actionPermits,
  envConfig,
  isAdminTypeUser,
  ...props
}) => {
  const CLIENT = envConfig.clientId || 'INTEG'
  const { setSpinning, spinning } = useContext(SpinContext)
  const { error, setError } = useContext(ErrorContext)

  const { selectedUnits } = useContext(UnitSelectionContext)
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)

  const [tmpMonthlyPie, setTmpMonthlyPie] = useState([])
  const [monthlydata, setMonthlydata] = useState([])
  const [tmpcard97, setTmpcard97] = useState([])
  const [perfDisplay, setPerfDisplay] = useState([])
  const [monthlyGraph, setMonthlyGraph] = useState([])
  const [monthlyGraphLimit, setMonthlyGraphLimit] = useState(0)

  const [utility, setUtility] = useState(
    (selectedUnits[0] || {}).utility || (units[0] || {}).utility
  )
  const [unit, setUnit] = useState(
    (selectedUnits[0] || {}).unitId || (units[0] || {}).unitId
  )
  const [card97Dominant, setCard97Dominant] = useState(false)
  const [unitCodeMap, setUnitCodeMap] = useState({})
  const [unitShortNameMap, setUnitShortNameMap] = useState({})
  const [timeZoneMap, setTimeZoneMap] = useState({})
  const [graphSelBar, setGraphSelBar] = useState([])

  const [isRetrieved, setIsRetrieved] = useState(null)
  const [retError, setRetError] = useState([])
  const [kpi, setKpi] = useState({})
  const [kpiError, setKpiError] = useState([])
  const [showKpiModal, setShowKpiModal] = useState(false)
  const [dataItemsKpi, setDataItemsKpi] = useState([])
  const [cardEditPrompt, setCardEditPrompt] = useState(false)
  const [cardEditPromptRowData, setCardEditPromptRowData] = useState({})
  const [cardEditPromptMode, setCardEditPromptMode] = useState('V')
  const [lock, setLock] = useState('U') // U unlock  L lock
  const [hoursWidth, setHoursWidth] = useState(10)
  const [selectedEventNum, setSelectedEventNum] = useState(0)
  const card97Ref = useRef()

  // useEffect(
  //   _ => {
  //     getAllUnitInfo(apiTargetInfo).fork(setError, allUnits => {
  //       // const utilityNameMap={}
  //       // const unitNameMap={}
  //       // const utilityUnitMap={}
  //       // const utilities=[]
  //       // const units=[]
  //       // setAllUnits(allUnits)
  //       const unitNameMap = R.compose(
  //         R.fromPairs,
  //         R.map(({ unitId, unitName }) => [unitId, unitName])
  //       )(allUnits)
  //       setUnitNameMap(unitNameMap)

  //       const utilityUnitMap = R.compose(
  //         R.fromPairs,
  //         // R.map(([k, v]) => [k, R.uniq(v)]),
  //         R.map(([k, v]) => [k, R.uniq(v.map(v => v.unitId))]),
  //         R.toPairs,
  //         R.groupBy(d => d.utility),
  //         R.map(({ unitId, utility }) => ({ unitId, utility }))
  //       )(allUnits)
  //       // setUtilityUnitMap(utilityUnitMap)
  //     })
  //   },
  //   [apiTargetInfo, setError]
  // )

  const [causeCodeList, setCauseCodeList] = useState([])
  useEffect(
    _ => {
      getCauseCodeAll(apiTargetInfo).fork(setError, setCauseCodeList)
    },
    [apiTargetInfo, setError]
  )

  useEffect(() => {
    if (card97Ref.current !== undefined) {
      const num = card97Ref.current.generateViewProps().view.findIndex(
        // eslint-disable-next-line eqeqeq
        d => d.eventIdx === '1' && d.eventNum == graphSelBar.eventNum
      )
      if (card97Ref.current !== undefined && num >= 0)
        card97Ref.current.setSelectedRect({ y1: num, y2: num, x1: 1, x2: 3 })
    }
  }, [graphSelBar, tmpcard97])

  useEffect(() => {
    getSystemConfigurationInfo(apiTargetInfo).fork(setError, d => {
      const dominantData = d.filter(
        s => s.key === 'DOMINANT_DERATE' && s.value === 'YES'
      )
      setCard97Dominant(dominantData.length > 0)
    })

    getDataItems(apiTargetInfo).fork(setError, d =>
      setDataItemsKpi(
        d
          .filter(e => e.defSeq > 15)
          .sort((a, b) =>
            (a.displayName || '').localeCompare(b.displayName || '')
          )
      )
    )
  }, [apiTargetInfo, setError])

  useEffect(() => {
    setTimeZoneMap(timeZoneList(units))
    setUnitCodeMap(unitCodeList(units))
    setUnitShortNameMap(unitShortNameList(units))
  }, [units])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getDomValue = useCallback(
    (ioCode, eventType, utility, unit) => {
      /*
         if (rs.getString("IOCODE") != null && rs.getString("IOCODE").trim().length() > 0) {
                iocode = Integer.parseInt(rs.getString("IOCODE"));
                if ((ruleSet.equalsIgnoreCase("MISO") || ruleSet.equalsIgnoreCase("NERC")) &&
                        (eventType$.equalsIgnoreCase("D1") || eventType$.equalsIgnoreCase("D2") || eventType$.equalsIgnoreCase("D3") ||
                                eventType$.equalsIgnoreCase("D4") || eventType$.equalsIgnoreCase("PD"))) {
                    if (iocode == 0)
                        dominant = "N";
                    else if (iocode == -1)
                        dominant = "Y";
                    else
                        dominant = "na";
                } else
                    dominant = "na";

            } else
                dominant = "na";
    */
      if (ioCode === undefined || ioCode == null || ioCode.trim().length <= 0)
        return 'na'
      else {
        const matchedUnit = units.find(
          u => u.utility === utility && u.unit === unit
        )
        const ruleSet = matchedUnit && matchedUnit.ruleSet
        if (
          (ruleSet === 'MISO' || ruleSet === 'NERC') &&
          ['D1', 'D2', 'D3', 'D4', 'PD'].includes(eventType)
        ) {
          const ioVal = parseInt(ioCode)
          if (ioVal === 0) return 'N'
          else if (ioVal === -1) return 'Y'
        }
      }
      return 'na'
    },
    [units]
  )

  const retrieveKpi = useCallback(
    date => {
      const year = (date || selectedDate).format('YYYY')
      const month = (date || selectedDate).format('MM')
      getKpi(apiTargetInfo)({
        year,
        month,
        utility,
        unit: unit.substr(utility.lenght),
      }).fork(setError, data => {
        if (
          data.resultStatus.find(e => e.severity === '1' || e.severity === 1)
        ) {
          setKpiError(data.resultStatus)
          setKpi({ ...data, result: [] })
        } else {
          setKpi(data)
          setKpiError([])
        }
      })
    },
    [apiTargetInfo, selectedDate, setError, unit, utility]
  )
  const retrieveData = useCallback(
    ({ date = selectedDate }) => {
      if (unit === undefined) {
        message.error('Please, Select Unit')
        // setVisibleUnitSelection(true)
      } else if (!units.find(e => e.unitId === unit)) {
        message.error('Please, Select Unit')
      } else if (utility === undefined) {
        message.error('Please, Select Unit')
      } else {
        setSpinning(true)
        getMonthlyViewData(apiTargetInfo)(
          date.format('YYYY'),
          date.format('MM'),
          utility,
          unit.substr(3),
          units.find(e => e.unitId === unit).shortName
        ).fork(setError, map => {
          setIsRetrieved(true)
          setMonthlyGraphLimit(map.OUT_DATA_GRAPH_LIMIT || 0)
          setTmpMonthlyPie(map.TMP_MONTHLY_PIE)
          setMonthlydata(map.MONTHLY_DISPLAY)
          setRetError(map.ERRORS || [])
          setTmpcard97(
            map.TEMPCARD97.map(row => ({
              ...row,
              dom: getDomValue(
                row.ioCode,
                row.eventType,
                row.utility,
                row.unit
              ),
            }))
          )
          setPerfDisplay(map.PERF_DISPLAY)
          setMonthlyGraph(map.TMP_MONTHLY_GRAPH)
          setLock(isAdminTypeUser ? 'U' : map.LOCK)
          setSpinning(false)
          retrieveKpi(date)
        })
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // date change units so retrieve call 2 times
      apiTargetInfo,
      // getDomValue,
      retrieveKpi,
      selectedDate,
      setError,
      setSpinning,
      unit,
      units,
      utility,
    ]
  )
  // useEffect(() => {
  //   retrieveData()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedDate])

  const unitCodeCauseCodeMap = useMemo(
    _ => getUnitCodeCauseCodeMapList(causeCodeList),
    [causeCodeList]
  )

  const showKpiData = _ => {
    Modal.info({
      title: `KPI Data`,
      width: 500,
      // height: 800,
      // style: { height: 800 },
      content: (
        <div style={{ height: 300 }}>
          <KpiData
            data={kpi.result}
            setting={kpi.setting || {}}
            idWidth={200}
            dtWidth={150}
            grWidth={350}
            grHeight={400}
          />
        </div>
      ),
    })
  }
  return (
    <>
      <CriteriaRow style={{ width: '100%', padding: '10px' }}>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          {title}
        </Title>
        <UtilityUnitSelection
          defaultValue={[utility, unit]}
          utility={utility}
          unit={unit}
          onUnitChange={value => {
            setUtility(value[0])
            setUnit(value[1])
            setIsRetrieved(false)
          }}
          style={{ width: '600px' }}
          // apiTargetInfo={apiTargetInfo}
          // utilityNameMap={utilityNameMap}
          // unitNameMap={unitNameMap}
          // utilityUnitMap={utilityUnitMap}
          // utilities={utilities}
          // units={units}
        />
        <DatePicker.MonthPicker
          allowClear={false}
          format="MMMM-YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d.endOf('month'))
            setIsRetrieved(false)
            retrieveData({ date: d.startOf('month') })
          }}
          style={{ marginLeft: '10px' }}
        />

        <Button.Group style={{ minWidth: '130px', marginLeft: '10px' }}>
          <Button
            style={{ marginLeft: '10px' }}
            type="primary"
            onClick={() => {
              setSelectedDate(selectedDate.clone().subtract(1, 'months'))
              setIsRetrieved(false)
              retrieveData({
                date: selectedDate
                  .clone()
                  .subtract(1, 'months')
                  .startOf('month'),
              })
            }}
          >
            <Icon type="left" />
          </Button>

          <Button
            style={{}}
            type="primary"
            onClick={() => {
              setSelectedDate(selectedDate.clone().add(1, 'months'))
              setIsRetrieved(false)
              retrieveData({
                date: selectedDate
                  .clone()
                  .add(1, 'months')
                  .startOf('month'),
              })
            }}
          >
            <Icon type="right" />
          </Button>
        </Button.Group>

        <Button
          style={{ marginLeft: '10px' }}
          type="primary"
          onClick={() => retrieveData({})}
          icon="database"
        >
          Retrieve
        </Button>
      </CriteriaRow>

      <FullHeightSizer heightOffset={200}>
        {({ height, width }) =>
          isRetrieved ? (
            <Content style={{ marginTop: '10px', padding: '5px', height }}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'minmax(auto,min-content) 190px',
                  gridTemplateRows:
                    'minmax(min-content,min-content) min-content min-content auto',
                  gridColumnGap: '5px',
                  gridRowGap: '2px',
                  // maxHeight: height,
                  height: '100%',
                  justifyContent: 'space-between',
                  marginRight: '10px',
                }}
              >
                <MonthlyGraph
                  apiTargetInfo={apiTargetInfo}
                  setError={setError}
                  error={error}
                  setSpinning={setSpinning}
                  spinning={spinning}
                  year={selectedDate.format('YYYY')}
                  utility={utility}
                  unit={unit}
                  setCardEditPromptRowData={setCardEditPromptRowData}
                  setCardEditPrompt={setCardEditPrompt}
                  setCardEditPromptMode={setCardEditPromptMode}
                  cardData={tmpcard97.filter(d => d.eventIdx === '1')}
                  date={selectedDate.clone()}
                  data={monthlyGraph}
                  limit={monthlyGraphLimit}
                  isValid={!R.isNil(monthlyGraphLimit)}
                  setMonthlyGraphRectSelection={setGraphSelBar}
                  monthlydata={monthlydata}
                  selectedMonthYear={selectedDate}
                  // width={width - 250 > 900 ? width - 250 : 1000}
                  width={width - 210}
                  tmpMonthlyPie={tmpMonthlyPie}
                  screenSize={{ height, width }}
                  perfDisplay={perfDisplay}
                  retrieveData={_ => retrieveData({})}
                  lock={lock}
                  setHoursWidth={setHoursWidth}
                  selectedEventNum={selectedEventNum}
                  envConfig={envConfig}
                  actionPermits={actionPermits}
                  unitShortNameMap={unitShortNameMap}
                  unitList={units}
                  isAdminTypeUser={isAdminTypeUser}
                />

                <TmpCard97
                  CLIENT={CLIENT}
                  cref={card97Ref}
                  setCardEditPromptRowData={setCardEditPromptRowData}
                  setCardEditPrompt={setCardEditPrompt}
                  setCardEditPromptMode={setCardEditPromptMode}
                  style={{ gridColumnGap: 'span 1' }}
                  retrieveData={_ => retrieveData({})}
                  data={tmpcard97
                    .filter(d => d.eventIdx === '1')
                    .map(d => ({
                      ...d,
                      causeDescription:
                        causeCodeMap[d.causeCode] || d.causeCode || '',
                    }))}
                  unitNameMap={unitNameMap}
                  utilityNameMap={utility}
                  date={selectedDate}
                  selUtility={utility}
                  selUnit={unit === undefined ? '' : unit}
                  idxData={tmpcard97.filter(d => d.eventIdx !== '1')}
                  ampCodeMap={props.ampCodeMap}
                  failCodeMap={props.failCodeMap}
                  unitCodeMap={unitCodeMap}
                  unitShortNameMap={unitShortNameMap}
                  causeCodeMap={causeCodeMap}
                  card97Dominant={card97Dominant}
                  targetInfo={apiTargetInfo}
                  timeZoneMap={timeZoneMap}
                  monthlyGraphRectSelection={{}}
                  screenSize={{
                    width: width - 220,
                    height: height - 500 < 0 ? 100 : height - 500,
                  }}
                  unitList={units}
                  graphSelBar={graphSelBar}
                  utility={utility}
                  unit={unit}
                  selectedMonthYear={selectedDate}
                  lock={lock}
                  hoursWidth={hoursWidth + 50}
                  setSelectedEventNum={setSelectedEventNum}
                  envConfig={envConfig}
                  actionPermits={actionPermits}
                  causeCodeList={causeCodeList}
                  isAdminTypeUser={isAdminTypeUser}
                />

                <div
                  style={{
                    display: 'grid',
                    paddingTop: '10px',
                    gridRowGap: '5px',
                    gridTemplateRows: 'min-content min-content auto',
                  }}
                >
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'auto 20%',
                      gap: '2%',
                    }}
                  >
                    <Tooltip
                      title={
                        kpi.setting
                          ? `${
                              kpi.setting.nercOrIso === 'N' ? 'NERC' : 'ISO'
                            } , 
                        Include OMC : ${
                          kpi.setting.omc === 'I' ? 'Yes' : 'No'
                        } ,
                        ${getKpiValueTitle(kpi.setting.period)}`
                          : ''
                      }
                    >
                      <Button
                        icon="control"
                        type="dashed"
                        onClick={() => setShowKpiModal(true)}
                        style={{ width: '100%' }}
                        disabled={
                          !hasAccesPermits({
                            authGodMode: envConfig.authGodMode,
                            actionPermits,
                            eventActions: [
                              ScreenPermissions.MONTHLY_OPERATION_ADMIN_KPI_DATA,
                            ],
                            matchAny: true,
                          })
                        }
                      >
                        KPI Config
                      </Button>
                    </Tooltip>
                    <Tooltip title="Show KPI">
                      <Button icon="to-top" onClick={showKpiData} />
                    </Tooltip>
                  </div>
                  {hasAccesPermits({
                    authGodMode: envConfig.authGodMode,
                    actionPermits,
                    eventActions: [
                      ScreenPermissions.MONTHLY_OPERATION_ADMIN_KPI_DATA,
                      ScreenPermissions.MONTHLY_OPERATION_VIEW_KPI_DATA,
                    ],
                    matchAny: true,
                  }) && (
                    <KpiData data={kpi.result} setting={kpi.setting || {}} />
                  )}
                  {showKpiModal && (
                    <KpiModal
                      data={kpi}
                      setting={kpi.setting || {}}
                      visible={showKpiModal}
                      setShowKpiModal={setShowKpiModal}
                      showModal={showKpiModal}
                      setErr={setError}
                      retrieveKpi={retrieveKpi}
                      selectedData={(kpi.template || []).map(e => e.ident)}
                      dataItemsKpi={dataItemsKpi}
                      envConfig={envConfig}
                      actionPermits={actionPermits}
                    />
                  )}
                </div>
              </div>
            </Content>
          ) : (
            <Content
              style={{
                marginTop: '10px',
                padding: '5px',
                height,
              }}
            >
              <Empty
                imageStyle={{ paddingTop: '30px' }}
                description={
                  unit == null
                    ? 'Please select unit'
                    : !isRetrieved
                    ? 'Please click on retrieve button to retrieve data'
                    : 'No Data from Retrieve'
                }
              />
            </Content>
          )
        }
      </FullHeightSizer>

      {kpiError && (
        <JcTmpErrorDialog
          errors={kpiError}
          visible={kpiError.length !== 0}
          closeErrorPrompt={() => setKpiError([])}
          title="KPI Errors/Warning"
        />
      )}

      {retError && (
        <JcTmpErrorDialog
          errors={retError}
          visible={retError.length !== 0}
          closeErrorPrompt={() => setRetError([])}
          // title="KPI Errors/Warning"
        />
      )}
      {cardEditPrompt && (
        <Card97EditPrompt
          CLIENT={CLIENT}
          key="card97editpromptq"
          mode={cardEditPromptMode}
          apiTargetInfo={apiTargetInfo}
          setPrompt={setCardEditPrompt}
          rowData={cardEditPromptRowData}
          utilityNameMap={utilityNameMap}
          unitNameMap={unitNameMap}
          criteriaYear={selectedDate.format('YYYY')}
          utility={utility}
          unit={unit}
          // setPromptMsg={this.setPromptMsg}
          timeZoneMap={timeZoneMap}
          card97Dominant={card97Dominant}
          unitsList={units}
          ampCodeMap={props.ampCodeMap}
          failCodeMap={props.failCodeMap}
          unitCodeMap={unitCodeMap}
          unitShortNameMap={unitShortNameMap}
          idxData={
            cardEditPromptMode === 'N'
              ? []
              : tmpcard97.filter(
                  d =>
                    d.eventNum === cardEditPromptRowData.eventNum &&
                    d.eventIdx !== '1'
                )
          }
          causeCodeMap={causeCodeMap}
          setEditPromptvisible={setCardEditPrompt}
          promptEdit={cardEditPrompt}
          headers={card97headers}
          retrieveData={_ => retrieveData({})}
          causeCodeList={causeCodeList}
          unitCodeCauseCodeMap={unitCodeCauseCodeMap}
          allowRetrieve
        />
      )}
    </>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  units: getUnits(state),
  causeCodeMap: getCauseCodeMap(state),
  unitLoading: isUnitLoading(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  ampCodeMap: getAmlificationCode(state),
  failCode: getFailCode(state),
  isAdminTypeUser: isAdminType(state),
  utilities: getUtilities(state),
})

const MonthlyPerf = connect(mapStateToProps)(MonthlyPerformance)
export default MonthlyPerf

const timeZoneList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.timeZone])
)

const unitCodeList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.id1])
)

const unitShortNameList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.shortName])
)
